// src/app/core/strategies/transloco-title.strategy.ts
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TranslocoTitleStrategy extends TitleStrategy {
  private lastSnapshot: RouterStateSnapshot | null = null;

  constructor(private readonly title: Title, private readonly transloco: TranslocoService) {
    super();

    this.transloco.langChanges$.subscribe(() => {
      if (this.lastSnapshot) this.updateTitle(this.lastSnapshot);
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.lastSnapshot = snapshot;

    const key = this.buildTitle(snapshot);
    if (!key) {
      this.title.setTitle('Email App');
      return;
    }

    this.transloco
      .selectTranslate(key)
      .pipe(take(1))
      .subscribe({
        next: (translated) => {
          this.title.setTitle(`${translated} | Email App`);
        },
        error: () => {
          this.title.setTitle('Email App');
        },
      });
  }
}
